export type AppView = "history" | "change_orders" | "portfolio" | "onboarding" | "settings" | "sikkerhet";

export interface ChangeOrder {
  id: string;
  co_number: string;
  description: string;
  amount: number;
  currency: string;
  status: string;
  approved_by: string | null;
  approved_by_user_id: string | null;
  approved_by_role: string | null;
  approved_date: string | null;
  created_by_user_id: string | null;
  created_by_name: string | null;
  created_by_role: string | null;
  has_documentation: boolean;
  contract_id: string | null;
  created_at: string;
}

// avvikstype-etiketter er flyttet til i18n (`avvikstype.*` i en/nb) — bruk
// t(`avvikstype.${type}`) i komponenter slik at en FIDIC-kunde får engelsk tekst.

export function fmt(v: number | null | undefined, currency: string = "NOK") {
  if (v == null) return `${currency} 0.00`;
  return `${currency} ${v.toLocaleString("en-US", { minimumFractionDigits: 2 })}`;
}

/**
 * F4: avrundingsregel for prosenter. Backend EIER avrundingen og returnerer ferdig
 * avrundede %-tall (1 desimal) — vis dem verbatim. Denne helperen brukes KUN der frontend
 * MÅ aggregere selv (vindusavhengige tall uten backend-ekvivalent), så regelen er lik overalt.
 * 1 desimal, samme presisjon som backend.
 */
export function round1(v: number): number {
  return Math.round(v * 10) / 10;
}
